const ReadSkeletonLoader = () => {
    return (
        <>     
            <div className="skeleton-loader-title"></div>
            <div className="skeleton-loader-content-long"></div>
            <div className="skeleton-loader-content-long"></div>
            <div className="skeleton-loader-content-long"></div>
            <div className="skeleton-loader-content-long"></div>
            <div className="skeleton-loader-content-long"></div>
            <div className="skeleton-loader-content-short"></div>
            <div className="skeleton-loader-content-short"></div>
            <div className="skeleton-loader-content-long"></div>
            <div className="skeleton-loader-content-long"></div>
            <div className="skeleton-loader-content-long"></div>

        </>
    )
}

export default ReadSkeletonLoader
